export default function Footer() {
  const footerLinks = [
    {
      title: '快速导航',
      items: [
        { label: '热播榜单', href: '#ranking' },
        { label: '最新快讯', href: '#updates' },
        { label: '热门话题', href: '#topics' },
        { label: '影视索引', href: '#index' },
      ],
    },
    {
      title: '平台服务',
      items: [
        { label: '平台特色', href: '#features' },
        { label: '移动观影', href: '#app' },
        { label: '常见问题', href: '#faq' },
        { label: '联系我们', href: '#contact' },
      ],
    },
    {
      title: '关于我们',
      items: [
        { label: '平台介绍', href: '#about' },
        { label: '用户评价', href: '#comments' },
        { label: '精选专题', href: '#carousel' },
        { label: '热门影片', href: '#cards' },
      ],
    },
  ];

  return (
    <footer id="footer" className="bg-background-950 text-background-200">
      <div className="w-full px-4 md:px-6">
        <div className="py-12 md:py-16">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-10">
            <div className="col-span-2 md:col-span-1">
              <a href="#hero" className="inline-flex items-center gap-2 mb-4 group cursor-pointer">
                <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500 text-background-50 font-heading text-lg font-bold">
                  91
                </span>
                <span className="font-heading text-lg font-bold text-background-50">
                  91电影视频
                </span>
              </a>
              <p className="text-sm text-background-400 leading-relaxed max-w-xs">
                91电影视频汇聚国产精品影视，涵盖最新国产电影、电视剧、自制剧，高清免费在线观看，无需缓冲，每日更新。为国产影视爱好者提供一站式观影体验。
              </p>
            </div>

            {footerLinks.map((group) => (
              <div key={group.title}>
                <h4 className="text-sm font-semibold text-background-100 mb-3">
                  {group.title}
                </h4>
                <ul className="space-y-2">
                  {group.items.map((link) => (
                    <li key={link.href}>
                      <a
                        href={link.href}
                        className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer"
                      >
                        {link.label}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          <div className="mt-12 pt-8 border-t border-background-800/60">
            <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
              <div className="flex flex-wrap items-center gap-4 text-xs text-background-500">
                <span>91电影视频</span>
                <span className="hidden sm:inline">·</span>
                <span>国产精品影视免费在线观看平台</span>
              </div>
              <div className="flex items-center gap-4 text-xs text-background-500">
                <span className="whitespace-nowrap">合作伙伴</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}